export const SET_JOURNALEINTRAGTYPEN = "setJournalEintragTypen";
export const SET_JOURNALEINTRAGSTATI = "setJournalEintragStati";
export const SET_JOUNRALEINTRAGTEMPLATES = "setJournalEintragTemplates";
